import JwtData from './JwtData'

export enum PanelMode {
  PUBLIC = 'public',
  PHARMACY = 'pharmacy',
}

const panelModeStorageKey = 'panelMode'
const panelModeExplicitStorageKey = 'panelModeExplicit'

export const canUsePharmacyPanel = (): boolean => {
  const jwtData = new JwtData()
  const currentPharmacyName = jwtData.userData.pharmacyName
  const mainPharmacyName = localStorage.getItem('mainPharmacyName')
  const pharmacyName = currentPharmacyName || mainPharmacyName

  return Boolean(
    pharmacyName && pharmacyName !== 'null' && pharmacyName !== 'undefined',
  )
}

export const getPanelMode = (): PanelMode => {
  if (!canUsePharmacyPanel()) return PanelMode.PUBLIC

  const storedMode = localStorage.getItem(panelModeStorageKey)
  const wasExplicitlySelected =
    localStorage.getItem(panelModeExplicitStorageKey) === 'true'

  if (storedMode === PanelMode.PUBLIC && wasExplicitlySelected) {
    return PanelMode.PUBLIC
  }

  if (storedMode !== PanelMode.PHARMACY) {
    localStorage.setItem(panelModeStorageKey, PanelMode.PHARMACY)
  }
  return PanelMode.PHARMACY
}

export const initializePanelMode = (): PanelMode => {
  const mode = canUsePharmacyPanel() ? PanelMode.PHARMACY : PanelMode.PUBLIC
  localStorage.setItem(panelModeStorageKey, mode)
  localStorage.removeItem(panelModeExplicitStorageKey)
  return mode
}

export const setPanelMode = (mode: PanelMode): PanelMode => {
  const validMode =
    mode === PanelMode.PHARMACY && !canUsePharmacyPanel()
      ? PanelMode.PUBLIC
      : mode
  localStorage.setItem(panelModeStorageKey, validMode)
  localStorage.setItem(panelModeExplicitStorageKey, 'true')
  return validMode
}

export const isPublicPanel = (): boolean => getPanelMode() === PanelMode.PUBLIC

export const isPharmacyPanel = (): boolean =>
  getPanelMode() === PanelMode.PHARMACY
